<template>
  <button
    :type="buttonType"
    :class="`px-4 py-2 rounded font-medium text-sm transition-colors duration-200 ${typeClass}`"
    @click.stop="$emit('click')"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "BaseButton",
  emits: ["click"],
  props: {
    type: {
      type: String,
      default: "primary", // primary / danger / secondary
    },
    buttonType: {
      type: String,
      default: "button",
    },
  },
  computed: {
    typeClass() {
      switch (this.type) {
        case "danger":
          return "bg-red-500 hover:bg-red-600 text-white";
        case "secondary":
          return "bg-gray-300 hover:bg-gray-400 text-gray-800";
        default:
          return "bg-blue-500 hover:bg-blue-600 text-white";
      }
    },
  },
};
</script>
